
(function() {
    'use strict';

    var windowPopup = document.querySelectorAll('[gr-popup]');

    if (windowPopup.length > 0) {
        for ( var x=0, len = windowPopup.length; x < len; x++ ) {
            windowPopup[x].addEventListener('click', function(event) {
                event.preventDefault();

                var w = window,
                    d = document,
                    de = d.documentElement,
                    g = d.getElementsByTagName('body')[0],
                    x = w.innerWidth || de.clientWidth || g.clientWidth,
                    y = w.innerHeight || de.clientHeight || g.clientHeight;

                var winHeight = 400,
                    winWidth = 600,
                    winTop = (y / 2) - (winHeight / 2),
                    winLeft = (x / 2) - (winWidth / 2),
                    url = this.getAttribute('href');

                window.open(url, '_blank', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            });
        }
    }


})();
